import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchTeam from "utils/fetch/FetchTeam";

export default class FetchCachedTeam
{
	static logName = 'FetchCachedTeam';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'teams',
				tables: [ 'teams' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
					onFresh: () => {
						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess({
								teams: this.values
							})
						}
					},
					onExpired: () => {
						this.reload( { callbackSuccess, callbackError, callbackStart } )
					}
				})
			);
		}
		);
	}
	
	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchTeam.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( { teams = null } ) => {
						// Save to object!
						this.process( teams );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, teams, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess({
								teams: teams
							});
						}
					}
				})
			);
		}
		);
	}
	
	static process = ( teams ) => {
		this.values = teams;
		store.dispatch( addDataByGuid( dataConstants.TEAMS, this.values ) );
	}
}
